"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var agenda_html_1 = __importDefault(require("./agenda.html"));
var admin_dashboard_agenda_controller_1 = __importDefault(require("./admin-dashboard-agenda.controller"));
function prepareFilters(CalendarModel, DrivesFilterService) {
    var availableServices = DrivesFilterService.getFilterOptions();
    if (availableServices.services.length > 0) {
        return availableServices;
    }
    return CalendarModel.getFilterOptions().then(function (response) {
        DrivesFilterService.setFilterOptions(response.options);
        return response.options;
    });
}
prepareFilters.$inject = ["CalendarModel", "DrivesFilterService"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.agenda", {
        url: "/agenda/:date",
        controller: admin_dashboard_agenda_controller_1.default,
        controllerAs: "vm",
        resolve: {
            filterOptions: prepareFilters,
        },
        template: agenda_html_1.default,
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.owner,
                USER_ROLES.administrator,
                USER_ROLES.staff,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.dashboard.calendar.agenda", [])
    .config(config)
    .controller("AdminAgendaController", admin_dashboard_agenda_controller_1.default);
